exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".booking-cms__benefits[data-v-0f861928] {\n  width: 100%;\n  max-width: 740px;\n}\n.booking-cms__benefits-title[data-v-0f861928] {\n  margin-bottom: min(15px, 1em);\n}", ""]);

// exports
